import React, { createContext, useContext, useState, useEffect } from 'react';
import { useColorScheme } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

const themes = {
  light: {
    background: '#F0E6D2',
    text: '#4A4A4A',
    primary: '#E67E22',
    secondary: '#E8DCC0',
    border: '#D4C4A8',
    card: '#FFFFFF',
    muted: '#7A7A7A',
  },
  dark: {
    background: '#000000',
    text: '#FFFFFF',
    primary: '#FFA500',
    secondary: '#1A1A1A',
    border: '#333333',
    card: '#1A1A1A',
    muted: '#999999',
  }
};

export const ThemeProvider = ({ children }) => {
  const colorScheme = useColorScheme();
  const [currentTheme, setCurrentTheme] = useState('dark');
  const [themeValues, setThemeValues] = useState(themes.dark);

  useEffect(() => {
    loadTheme();
  }, []);

  useEffect(() => {
    // Auto-apply system theme
    if (currentTheme === 'system') {
      const systemTheme = colorScheme === 'light' ? 'light' : 'dark';
      setThemeValues(themes[systemTheme]);
    } else {
      setThemeValues(themes[currentTheme]);
    }
  }, [currentTheme, colorScheme]);

  const loadTheme = async () => {
    try {
      const savedTheme = await AsyncStorage.getItem('theme');
      if (savedTheme) {
        const theme = JSON.parse(savedTheme);
        setCurrentTheme(theme);
      }
    } catch (e) {
      console.warn('Error loading theme:', e);
    }
  };

  const changeTheme = async (theme) => {
    try {
      setCurrentTheme(theme);
      await AsyncStorage.setItem('theme', JSON.stringify(theme));
    } catch (e) {
      console.warn('Error saving theme:', e);
    }
  };

  return (
    <ThemeContext.Provider value={{ currentTheme, themeValues, changeTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;
